import type { DashboardNavigation } from "@/api/sidebarEntryAPI";
import { createContext, useContext } from "react";

type SelectedCustomerContextValue = {
    selectedCustomerId?: number;
    dashboardNavigation?: DashboardNavigation;
    isDashboardNavigationPending: boolean;
};

export const SelectedCustomerContext = createContext<SelectedCustomerContextValue>({
    isDashboardNavigationPending: false,
});

export function useSelectedCustomer() {
    return useContext(SelectedCustomerContext);
}

export function useSelectedCustomerIdParam() {
    const { selectedCustomerId } = useSelectedCustomer();
    return selectedCustomerId ? String(selectedCustomerId) : "";
}
